"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Document = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "0 0 24 24", style: style },
        React.createElement("defs", null,
            React.createElement("path", { id: "document_a", d: "M18 4H6c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-6 13H8v-2h4v2zm4-4H8v-2h8v2zm0-4H8V7h8v2z" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "document_b", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#document_a" })),
            React.createElement("g", { fill: color, mask: "url(#document_b)" },
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
};
exports.Document = Document;
//# sourceMappingURL=Document.js.map